import { cn } from '@/lib/utils'

/**
 * Rombex flowing wave background — blue & white only (no green).
 * Bridge-inspired smooth drifting gradient bands with darker hover effect for header/footer.
 */
export function WaveBackground({
  className,
  position = 'top',
}: {
  className?: string
  position?: 'top' | 'middle' | 'bottom'
}) {
  return (
    <div
      aria-hidden="true"
      className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}
    >
      {/* Use wave image for header/footer with animation, gradients for middle */}
      {(position === 'top' || position === 'bottom') ? (
        <>
          {/* Animated wave image background */}
          <div
            className="absolute inset-0 animate-wave"
            style={{
              backgroundImage: 'url(/wave-bg.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: 0.9,
            }}
          />
          
          {/* Secondary wave layer with phase shift for flowing effect */}
          <div
            className="absolute inset-0 animate-wave-delayed"
            style={{
              backgroundImage: 'url(/wave-bg.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: 0.5,
              transform: 'scaleX(-1)',
            }}
          />

          {/* Smooth fade overlay */}
          <div
            className="absolute inset-0"
            style={{
              background:
                position === 'top'
                  ? 'linear-gradient(180deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.98) 90%)'
                  : 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.7) 100%)',
            }}
          />
        </>
      ) : (
        <>
          {/* Gradient layers for middle sections */}
          <div
            className="rombex-wave-layer absolute -inset-x-48 -top-32 h-[140%] w-[140%]"
            style={{
              background:
                'radial-gradient(ellipse 950px 550px at 25% 35%, rgba(34,211,238,0.25) 0%, transparent 55%), radial-gradient(ellipse 850px 500px at 75% 45%, rgba(76,111,229,0.2) 0%, transparent 55%)',
              filter: 'blur(80px)',
              opacity: 0.75,
            }}
          />

          <div
            className="rombex-wave-layer-2 absolute -inset-x-48 top-0 h-[140%] w-[140%]"
            style={{
              background:
                'radial-gradient(ellipse 800px 450px at 55% 65%, rgba(59,130,246,0.18) 0%, transparent 60%), radial-gradient(ellipse 750px 420px at 65% 25%, rgba(37,99,235,0.16) 0%, transparent 55%)',
              filter: 'blur(90px)',
              opacity: 0.7,
            }}
          />

          <div
            className="absolute -inset-x-40 top-1/3 h-80"
            style={{
              background:
                'radial-gradient(ellipse 1100px 350px at 50% 50%, rgba(120,160,255,0.08) 0%, transparent 65%)',
              filter: 'blur(100px)',
              opacity: 0.5,
            }}
          />

          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(180deg, rgba(255,255,255,0.88) 0%, rgba(255,255,255,0) 28%, rgba(255,255,255,0) 72%, rgba(255,255,255,0.88) 100%)',
            }}
          />
        </>
      )}
    </div>
  )
}
